import styled from "styled-components";
import { DEVICE } from "constant/device";

export const TemplateAndCompanySizePageContainer = styled.div`
  display: flex;
  background: ${(props) => props.bgColor};
  width: 750px;
  height: 480px;
  border-radius: 24px;
`;

export const MobileTemplateAndCompanySizePageContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background: ${(props) => props.bgColor};
  padding: 5% 9% 0;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -ms-box-sizing: border-box;

  @media ${DEVICE.xxs} {
    padding: 50px 25px 0;
  }
`;

export const IndustryTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  position: relative;
  margin-top: 20px;

  @media ${DEVICE.small} {
    margin-top: 30px;
    margin-bottom: 30px;
  }
`;
export const CompanySizeContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 20px;

  @media ${DEVICE.small} {
    margin-bottom: 30px;
  }
`;

export const DesktopChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;

  & > :not(:last-child) {
    margin-inline-end: 10px;
  }

  & > :first-child {
    margin-bottom: 12px;
  }
`;

export const IndustrySelectInputContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  align-items: center;
  flex-wrap: wrap;

  @media ${DEVICE.xxs} {
    align-items: flex-start;
  }
`;

export const CompanySizeWrapper = styled.div`
  display: flex;
`;

export const ErrorContainer = styled.div`
  display: flex;
  margin-top: 5px;
  position: absolute;
  width: 100%;
  bottom: ${(props) => (props.bottom ? props.bottom : "-17px")};

  @media ${DEVICE.xxs} {
    bottom: -20px;
  }
`;

export const SubmitButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${({ marginTop }) => marginTop || "20px"};
  @media ${DEVICE.xxs} {
    margin-block-end: 10px;
  }
`;

export const ContentContainer = styled.div``;

export const MobileChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 26px;

  & > :first-child {
    /* margin-bottom: 12px; */
  }
  & > :not(:last-child) {
    margin-inline-end: 10px;
    margin-block-end: 12px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  flex-direction: column;
`;

export const InputWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid ${(props) => props.borderColor};
  width: 100%;
`;

export const BusinessTypeContainer = styled.div`
  display: flex;
  margin-inline-end: 4px;
  margin-bottom: 6px;
`;

export const BusinessTypeButton = styled.div`
  display: flex;
  text-align: center;
  text-transform: capitalize;
  padding: ${(props) => props.padding};
  border-radius: 50px;
  font-size: 18px;
  line-height: 24px;
  outline: none;
  color: ${(props) => props.color};
  background-color: ${(props) => props.color};
  align-items: center;
  border: 1px solid ${(props) => props.color};
  cursor: pointer;

  & > :first-child {
    margin-inline-end: ${(props) => props.iconTextMargin};
  }

  @media ${DEVICE.small} {
    &:active {
      background-color: ${(props) => props.hoverColor};
      border-color: ${(props) => props.hoverColor};
    }
  }
  @media ${DEVICE.large}, ${DEVICE.medium} {
    &:hover {
      background-color: ${(props) => props.hoverColor};
      border-color: ${(props) => props.hoverColor};
    }
  }
`;
